import { apiClient } from './client';
import type { ChecksSummary } from '../types';

export const checksApi = {
  async getSummary(): Promise<ChecksSummary> {
    const { data } = await apiClient.get<ChecksSummary>('/checks/summary');
    return data;
  },
};
